import React from "react";

type Props = {};

export default function SpanLoading({}: Props) {
  return (
    <span className={`loading loading-dots loading-md text-secondary`}></span>
  );
}
